var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('router-view',{attrs:{"service-data":_vm.serviceData,"active-services":_vm.activeServices,"inactive-services":_vm.inactiveServices}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }